import { StepperType } from "../../../models/stepper";
import { useAppDispatch } from "../../../store/hooks";
import { setFlow } from "../../../store/reducers/stepper";
import { HeadingH2Atom, HeadingH3Atom, SpacerAtom } from "../../atoms";
import { TypographyAtom } from "../../atoms/typography";
import { IconButtonMolecule } from "../button";

export function PublicatieTypeMolecule() {
  const dispatch = useAppDispatch();

  const selectType = (type: StepperType) => {
    dispatch(setFlow(type));
  };

  return (
    <>
      <HeadingH2Atom>Wat wilt u aanleveren?</HeadingH2Atom>
      <SpacerAtom space={2} />
      <TypographyAtom>{["U kunt kiezen om documenten te publiceren of een dossier te maken."]}</TypographyAtom>

      <SpacerAtom space={8} />
      <HeadingH3Atom>Document publiceren</HeadingH3Atom>
      <SpacerAtom space={2} />
      <TypographyAtom>
        {[
          "Upload één of meerdere documenten.",
          "Deze staan los van elkaar, maar u kunt ze later altijd nog aan een dossier toevoegen.",
        ]}
      </TypographyAtom>
      <SpacerAtom space={2} />
      <IconButtonMolecule
        text={"Documenten publiceren"}
        id={"documenten_publiceren"}
        title={"Documenten publiceren"}
        onClick={() => selectType("Normal")}
        type={"primary"}
        icon={"icon-cta-right-white"}
      />

      <SpacerAtom space={8} />
      <HeadingH3Atom>Dossier maken</HeadingH3Atom>
      <SpacerAtom space={2} />
      <TypographyAtom>
        {[
          "Upload een dossier met documenten als een georganiseerde bundel.",
          "Dit is een extra stap voor u documenten gaat uploaden om te publiceren.",
        ]}
      </TypographyAtom>
      <SpacerAtom space={2} />
      <IconButtonMolecule
        text={"Dossier maken"}
        id={"dossier_maken"}
        title={"Dossier maken"}
        onClick={() => selectType("Dossier")}
        type={"default"}
        icon={"icon-cta-right"}
      />
    </>
  );
}
